let dash = null;

const _consoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string') {
    const msg = args[0];
    if (msg.includes('[CmcdController]') || msg.includes('[CapabilitiesFilter]')) return;
    // Benign dash teardown race: when a video's source/MediaSource is detached on a
    // scene switch, dash's SourceBufferSink poll (and cached init-segment appends)
    // fire once more against an already-removed SourceBuffer. dash catches these and
    // logs them via console.error, but the switch itself completes fine. Suppress
    // only these specific "removed from the parent media source" messages.
    if (
      msg.includes('[SourceBufferSink]') &&
      (msg.includes('has been removed from the parent media source') || msg.includes('Failed to set append window'))
    )
      return;
  }
  _consoleError(...args);
};

// Shared by the preload loader (services/asset.ts) and the post-reset re-apply in
// the playback saga (sagas/player/video.ts). reset() drops a player's settings back
// to dash's defaults, so both sites must set the same thing — keep it here so they
// cannot drift (a missing `gaps.enableSeekFix` on the re-apply wedged revisited
// videos in the gap loop described below).
export const dashStreamingSettings = {
  streaming: {
    cacheInitSegments: true,
    cmcd: { enabled: false },
    // The default CapabilitiesFilter (MediaCapabilities API) false-negatives our
    // webm/vp9 manifests: it strips every Representation until the AdaptationSet is
    // empty, so nothing is left to play and readyState never leaves 1.
    capabilities: { useMediaCapabilitiesApi: false },
    abr: { autoSwitchBitrate: { audio: true, video: true } },
    gaps: {
      // Encodes here often end ~0.1s short of the declared duration. On reaching it,
      // GapController jumps to end of stream while the seek fix — a stall detector
      // that seeks back after ~10 identical playback times — drags playback into the
      // gap again, and the two loop without ever finishing. Both halves are on by
      // default; disabling the seek fix breaks the cycle.
      enableSeekFix: false,
    },
  },
};

export async function dashjs() {
  if (dash == null) {
    dash = await import('dashjs');
  }

  return dash;
}
